import moment from 'moment-timezone'

export function getDateInTz(
  tz: string,
  date: string,
  formatToUse: string,
  terminalTz: string = null,
) {
  switch (tz) {
    case 'Browser':
      return moment(date).format(formatToUse)
    case 'Terminal':
      if (terminalTz) {
        return moment(date).tz(terminalTz).format(formatToUse)
      } else {
        return moment(date).format(formatToUse)
      }
    case 'UTC':
      return moment(date).tz('UTC').format(formatToUse)
  }
}
